import ROUTES from "./routesConfig";

import { Footer } from "../components/Guest/Footer";
import { Header as GuestHeader } from "../components/Guest/Header";
import { PrivateRoutes } from "../lib/PrivateRoutes";
import { Header } from "../components/LoggedInHeader";
import { Scope } from "../lib/Scope";
import { RedirectHome } from "../lib/RedirectHome";

import { NotFound } from "../pages/NotFound";
import { Login } from "../pages/Login";
import { SignUp } from "../pages/SignUp";
import { ForgotPassword } from "../pages/ForgotPassword";
import { ResetPassword } from "../pages/ResetPassword";
import { ForgotAccount } from "../pages/ForgotAccount";
import { Accounts } from "../pages/Accounts";
import { Profile } from "../pages/Profile";
import { ChangePassword } from "../pages/Profile/ChangePassword";
import { ChangePhone } from "../pages/Profile/ChangePhone";
import { ChangeEmail } from "../pages/Profile/ChangeEmail";
import { UserManagement } from "../pages/UserManagement";
import { InternalServerError } from "../pages/InternalServerError";
import { Dashboard } from "../pages/Dashboard";
import { Customers } from "../pages/Customers";
import { Administration } from "../pages/Administration";
import { Processing } from "../pages/Processing";
import { Customer } from "../pages/Customer";
import { Batch } from "../pages/Batch";
import { AdminPayment } from "../pages/AdminPayment";
import { Account } from "../pages/Account";
import { Emails } from "../pages/Email";
import { Reports } from "../pages/Reports";
import { Maintenance } from "../pages/Maintenance";
import { PermissionContainer } from "../lib/PermissionContainer";
import { Messages } from "../pages/Messages";
import { MessagesProvider } from "../lib/MessagesProvider";
import { Documents } from "../pages/Documents";
import { RequestsAndForms } from "../pages/RequestsAndForms";
import { Tasks } from "../pages/Tasks";
import { SystemUsers } from "../lib/PrivateRoutes/SystemUsers";
import { UserPayment } from "../pages/UserPayment";
import { UserPaymentHistory } from "../pages/Mobile/UserPaymentHistory";
import { EmailBulk } from "../pages/EmailBulk";

export const routes = [
  {
    element: <RedirectHome />,
    children: [
      {
        path: ROUTES.NOT_FOUND,
        element: <NotFound />
      },
      {
        path: ROUTES.HOME,
        element: <RedirectHome />
      },
      {
        path: ROUTES.INTERNAL_SERVER_ERROR,
        element: <InternalServerError />
      },
      {
        path: ROUTES.MAINTENENCE,
        element: <Maintenance />
      },
      {
        element: <GuestHeader />,
        children: [
          {
            element: <Footer />,
            children: [
              {
                path: ROUTES.LOGIN,
                element: <Login />
              },
              {
                path: ROUTES.SIGN_UP,
                element: <SignUp />
              },
              {
                path: ROUTES.FORGOT_PASSWORD,
                element: <ForgotPassword />
              },
              {
                path: ROUTES.RESET_PASSWORD,
                element: <ResetPassword />
              },
              {
                path: ROUTES.FORGOT_ACCOUNT,
                element: <ForgotAccount />
              }
            ]
          }
        ]
      },
      {
        element: <PrivateRoutes />,
        children: [
          {
            element: <Header />,
            children: [
              {
                element: <SystemUsers />,
                children: [
                  {
                    path: ROUTES.ACCOUNT,
                    element: <Account />
                  },
                  {
                    path: ROUTES.ACCOUNTS,
                    element: <Accounts />
                  },
                  {
                    path: ROUTES.OTHER_ACCOUNTS,
                    element: <Accounts />
                  }
                ]
              },
              {
                path: ROUTES.PROFILE,
                element: <Profile />
              }
            ]
          },
          {
            element: <Scope admin={false} />,
            children: [
              {
                element: <MessagesProvider />,
                children: [
                  {
                    element: <Header />,
                    children: [
                      {
                        path: ROUTES.MESSAGES,
                        element: <Messages />
                      }
                    ]
                  }
                ]
              },
              {
                element: <Header />,
                children: [
                  {
                    path: ROUTES.DOCUMENTS,
                    element: <Documents />
                  },
                  {
                    path: ROUTES.FILLABLE_FORMS,
                    element: <RequestsAndForms />
                  },
                  {
                    path: ROUTES.MOBILE_USER_PAYMENT_HISTORY,
                    element: <UserPaymentHistory />
                  }
                ]
              },
              {
                path: ROUTES.USER_PAYMENT,
                element: <UserPayment />
              }
            ]
          },
          {
            element: <Scope />,
            children: [
              {
                element: <PermissionContainer />,
                children: [
                  {
                    element: <Header />,
                    children: [
                      {
                        path: ROUTES.DASHBOARD,
                        element: <Dashboard />
                      },
                      {
                        path: ROUTES.USER_MANAGEMENT,
                        element: <UserManagement />
                      },
                      {
                        path: ROUTES.CUSTOMERS,
                        element: <Customers />
                      },
                      {
                        path: ROUTES.ADMINISTRATION,
                        element: <Administration />
                      },
                      {
                        path: ROUTES.PROCESSING,
                        element: <Processing />
                      },
                      {
                        path: ROUTES.EMAILS,
                        element: <Emails />
                      },
                      {
                        path: ROUTES.EMAILS_BULK,
                        element: <EmailBulk />
                      },
                      {
                        path: ROUTES.REPORTS,
                        element: <Reports />
                      },
                      {
                        path: ROUTES.BATCH,
                        element: <Batch />
                      },
                      {
                        path: ROUTES.CUSTOMER,
                        element: <Customer />
                      },
                      {
                        path: ROUTES.TASKS,
                        element: <Tasks />
                      }
                    ]
                  },
                  {
                    path: ROUTES.PAYMENT,
                    element: <AdminPayment />
                  }
                ]
              }
            ]
          },
          {
            element: <GuestHeader />,
            children: [
              {
                element: <Footer />,
                children: [
                  {
                    path: ROUTES.PROFILE_CHANGE_PASSWORD,
                    element: <ChangePassword />
                  },
                  {
                    path: ROUTES.PROFILE_CHANGE_PHONE,
                    element: <ChangePhone />
                  },
                  {
                    path: ROUTES.PROFILE_CHANGE_EMAIL,
                    element: <ChangeEmail />
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
